import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import Swal from "sweetalert2";
import { getStampFileCartaPorte } from "../../../services/CartaPorteService";
import axiosClient from "../../../config/axios.js";
const razonSocialAPI = "GruasVaro";

export const getOrdersBillingColumns = (
  orderStatusCode,
  fetchData,
  isAdmin
) => [
  {
    name: "Folio ",
    selector: (row) => (
      <>
        <div className="mb-2 text-center">
          <Link to={`/orders/edit/${row.id}`}>
            {row.folio.toString().padStart(5, "0")}
          </Link>
        </div>
        <div
          className="d-flex flex-column align-items-center"
          style={{ width: "120px" }}
        >
          <Link
            to={`/facturacion-ordenes/invoice/${row.id}`}
            className="btn btn-primary btn-sm mb-2 w-100"
          >
            Facturar
          </Link>
          <Link
            to={`/facturacion-ordenes/carta-porte/${row.id}`}
            className="btn btn-secondary btn-sm w-100"
          >
            Carta Porte
          </Link>

          {/* Botón Carta Porte */}
          {/* {row.stamped_cartaportes?.length > 0 && (
            <>
              <button
                className="btn btn-success btn-sm w-120"
                style={{ marginTop: "10px" }}
                onClick={async () => {
                  // Mostrar alerta antes de descargar
                  const confirm = await Swal.fire({
                    title: "Descargar Carta Porte",
                    text: "¿Deseas descargar la última Carta Porte de esta orden?",
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonText: "Sí, descargar",
                    cancelButtonText: "Cancelar",
                  });

                  if (!confirm.isConfirmed) return;

                  // Usamos el último stamp
                  const lastStamp =
                    row.stamped_cartaportes[row.stamped_cartaportes.length - 1];

                  try {
                    const fileResponse = await getStampFileCartaPorte(
                      lastStamp.uuid_stamp,
                      razonSocialAPI
                    );

                    if (fileResponse?.file?.url) {
                      const link = document.createElement("a");
                      link.href = fileResponse.file.url;
                      link.setAttribute(
                        "download",
                        `${fileResponse.file.name || "CartaPorte"}.${
                          fileResponse.file.extension || "pdf"
                        }`
                      );
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    } else {
                      Swal.fire(
                        "Ups!",
                        "No se pudo obtener el archivo de la Carta Porte",
                        "error"
                      );
                    }
                  } catch (err) {
                    console.error("Error al descargar Carta Porte:", err);
                    Swal.fire(
                      "Error",
                      "Ocurrió un error al descargar la Carta Porte",
                      "error"
                    );
                  }
                }}
              >
                Descargar CartaPorte
              </button>
              {isAdmin() && (
                <button
                  className="btn btn-danger btn-sm w-120"
                  style={{ marginTop: "10px" }}
                  onClick={async () => {
                    // Mostrar alerta antes de descargar
                    const confirm = await Swal.fire({
                      title: "Eliminar Carta Porte",
                      text: "¿Deseas eliminar la Carta Porte de esta orden?",
                      icon: "info",
                      showCancelButton: true,
                      confirmButtonText: "Sí, eliminar",
                      cancelButtonText: "Cancelar",
                    });

                    if (!confirm.isConfirmed) return;
                    try {
                      const response = await axiosClient.delete(
                        `/delete-stamped-carta-portes/${row.id}`
                      );
                      await fetchData({});
                    } catch (err) {
                      console.error("Error al eliminar Carta Porte:", err);
                      Swal.fire(
                        "Error",
                        "Ocurrió un error al eliminar la Carta Porte",
                        "error"
                      );
                    }
                  }}
                >
                  Eliminar CartaPorte
                </button>
              )}
            </>
          )} */}
        </div>
      </>
    ),
    sortable: true,
    sortField: "folio",
    width: "10%",
  },

  {
    name: (
      <>
        Fecha y Hora <br /> de Registro
      </>
    ),
    selector: (row) => (
      <>
        {format(new Date(row.fecha_hora_reporte), "dd/MMM/yyyy", {
          locale: es,
        })}
        <br />
        {format(new Date(row.fecha_hora_reporte), "hh:mm a", {
          locale: es,
        })}{" "}
        por
        <br />
        {(
          row?.base?.name +
          " " +
          row?.base?.first_surname +
          " " +
          (row?.base?.second_surname ? row?.base?.second_surname : "")
        ).trim()}
      </>
    ),
    sortable: true,
    sortField: "fecha_hora_reporte",
    width: "12%",
  },
  {
    name: (
      <>
        Última <br /> actualización
      </>
    ),
    selector: (row) => (
      <>
        {format(new Date(row.updatedAt), "dd/MMM/yyyy", { locale: es })}
        <br />
        {format(new Date(row.updatedAt), "hh:mm a", { locale: es })}
      </>
    ),
    sortable: true,
    sortField: "updatedAt",
    width: "12%",
  },
  {
    id: "order_status",
    omit: orderStatusCode ? true : false,
    name: (
      <>
        Estatus <br /> actual
      </>
    ),
    selector: (row) => (
      <span className="ms-1 mb-1 badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
        {row?.current_order_status?.order_status}
      </span>
    ),
    sortable: false,
    width: "10%",
  },
  {
    name: (
      <>
        Tipo de
        <br />
        Servicio
      </>
    ),
    width: "10%",
    cell: (row) => {
      const badges = [];
      const servicios = {
        grua: "Grúa",
        auxilio_vial: "Auxilio Vial",
        montacarga: "Montacarga",
        corresponsalia: "Corresponsalía",
        taxi: "Taxi",
      };

      for (const key in servicios) {
        if (row[key]) {
          badges.push(
            <span
              key={key}
              className="ms-1 mb-1 badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center"
            >
              {servicios[key]}
            </span>
          );
        }
      }
      return <div>{badges}</div>;
    },
  },
  {
    name: (
      <>
        Tipo de
        <br />
        Cliente
      </>
    ),
    selector: (row) => (
      <>
        {row?.ClientType?.client_type}
        {row?.Insurance?.insurance_name && (
          <>
            <br />
            {row?.Insurance?.insurance_name}
          </>
        )}
      </>
    ),
    sortable: false,
    width: "11%",
  },
  {
    name: "Vehículo",
    cell: (row) => {
      const vehicles = row?.Vehicles || [];
      const vehicleInfo = vehicles
        .map((vehicle) => {
          if (vehicle?.VehicleModel) {
            const { Brand, model_name } = vehicle.VehicleModel;
            const color = vehicle.Color?.color_name || "";
            const year = vehicle.anio || "";
            return `${Brand?.brand_name ? Brand?.brand_name + " " : ""}${
              model_name ? model_name + ", " : ""
            }${color ? color + ", " : ""}${year ? year + ", " : ""}`;
          }
          return "";
        })
        .join(" | ");
      return vehicleInfo;
    },
    sortable: false,
    width: "11%",
  },
  {
    name: "Operador",
    cell: (row) => {
      const operators = row?.OrderOperators || [];
      const operatorInfo = operators
        .map((operator) => {
          const { name, first_surname, second_surname } = operator.User;
          return `${name ? name + " " : ""}${
            first_surname ? first_surname + " " : ""
          }${second_surname || ""}`;
        })
        .join(" | ");
      return operatorInfo;
    },
    sortable: false,
    width: "11%",
  },
  {
    name: "Expediente",
    selector: (row) => row?.expediente,
    sortable: true,
    sortField: "expediente",
    width: "14%",
  },
  {
    name: "Beneficiario del Servicio",
    selector: (row) => (
      <>
        {row.cliente_vip && (
          <>
            <span className="mb-1 badge border border-warning text-warning px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
              Cliente VIP
            </span>
            <br />
          </>
        )}
        {row.beneficiario_servicio}
      </>
    ),
    sortable: true,
    sortField: "beneficiario_servicio",
    width: "16%",
  },
  {
    name: "Empresa",
    selector: (row) => row.empresa,
    sortable: true,
    sortField: "empresa",
    width: "15%",
  },
  {
    name: "Teléfono",
    selector: (row) => row.telefono_principal,
    sortable: true,
    sortField: "telefono_principal",
    width: "11%",
  },
  {
    name: (
      <>
        Fecha y Hora <br /> de Contacto
      </>
    ),
    omit: orderStatusCode ? false : true,
    selector: (row) =>
      row.fecha_hora_contacto && (
        <>
          {format(new Date(row.fecha_hora_contacto), "dd/MMM/yyyy", {
            locale: es,
          })}
          <br />
          {format(new Date(row.fecha_hora_contacto), "hh:mm a", { locale: es })}
        </>
      ),
    sortable: true,
    sortField: "fecha_hora_contacto",
    width: "10%",
  },
];

export const customStyles = {
  headCells: {
    style: {
      color: "#202124",
      fontSize: "14px",
      backgroundColor: "#EEEEEE",
      border: "none",
    },
  },
};
